import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';
import ProductListFilterHeader from './ProductListFilterHeader';
import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { Ecommerce, ProductList, SearchTableButton } from '../../../../utils/Constant';
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs';
import {
    productListTableData,
    productListTableDataColumn
} from '../../../../Data/Application/Ecommerce/ProductList';
import { Product, QueryParams } from '../../../../Types/Products';
import { PaginatedResponse } from '../../../../Types/Common';
import { AxiosResponse } from 'axios';
import { productsApi } from '../../../../Api';
import { useLocation } from 'react-router-dom';

const ProductListContainer = () => {
    const location = useLocation();
    const [queryParam, setQueryParam] = useState<QueryParams>({
        page: 1,
        pageSize: 15
    });

    const [products, setProducts] = useState<Product[]>([]);
    const [total, setTotal] = useState(0);
    const [isLoadingProducts, setIsLoadingProducts] = useState(false);

    const [filterText, setFilterText] = useState('');

    const filteredItems = productListTableData.filter(
        (item) => item.category && item.category.toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponentMemo = useMemo(() => {
        return (
            <div className="dataTables_filter d-flex align-items-center">
                <Label className="me-2">{SearchTableButton}:</Label>
                <Input
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setFilterText(e.target.value)
                    }
                    type="search"
                    value={filterText}
                />
            </div>
        );
    }, [filterText]);

    const getList = () => {
        setIsLoadingProducts(true);
        try {
            productsApi
                .getList(queryParam)
                .then((res: AxiosResponse<PaginatedResponse<Product>>) => {
                    setIsLoadingProducts(false);
                    setProducts(res.data.data);
                    setTotal(res.data.total);
                });
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getList();
    }, [queryParam, location]);

    const handleChangeQueryParam = (e: any) => {
        setQueryParam({ ...queryParam, ...e });
    };

    return (
        <>
            <Breadcrumbs
                mainTitle={'List'}
                parent={'Products'}
            />
            <Container fluid>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <div className="list-product-header">
                                    <ProductListFilterHeader />
                                    <CollapseFilterData />
                                </div>
                                <div className="list-product">
                                    <div className="table-responsive">
                                        <DataTable
                                            data={products}
                                            columns={productListTableDataColumn}
                                            progressPending={isLoadingProducts}
                                            striped
                                            highlightOnHover
                                            pagination
                                            paginationServer
                                            paginationTotalRows={total}
                                            onChangePage={(e: number) =>
                                                handleChangeQueryParam({ page: e })
                                            }
                                            selectableRows
                                            subHeader
                                            subHeaderComponent={subHeaderComponentMemo}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ProductListContainer;
